"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LootboxTransactionHistoryItemToJSON = exports.LootboxTransactionHistoryItemFromJSONTyped = exports.LootboxTransactionHistoryItemFromJSON = void 0;
var runtime_1 = require("../runtime");
function LootboxTransactionHistoryItemFromJSON(json) {
    return LootboxTransactionHistoryItemFromJSONTyped(json, false);
}
exports.LootboxTransactionHistoryItemFromJSON = LootboxTransactionHistoryItemFromJSON;
function LootboxTransactionHistoryItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'amount': !(0, runtime_1.exists)(json, 'amount') ? undefined : json['amount'],
        'amountFormatted': !(0, runtime_1.exists)(json, 'amountFormatted') ? undefined : json['amountFormatted'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'cartItems': !(0, runtime_1.exists)(json, 'cartItems') ? undefined : json['cartItems'],
        'createdAt': !(0, runtime_1.exists)(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
    };
}
exports.LootboxTransactionHistoryItemFromJSONTyped = LootboxTransactionHistoryItemFromJSONTyped;
function LootboxTransactionHistoryItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'amount': value.amount,
        'amountFormatted': value.amountFormatted,
        'status': value.status,
        'description': value.description,
        'cartItems': value.cartItems,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
    };
}
exports.LootboxTransactionHistoryItemToJSON = LootboxTransactionHistoryItemToJSON;
